import { Component } from '@angular/core';
import { SimulatorType } from '../../../core/enums/simulator-type.enum';

import { CubeTrendSimulatorComponent } from '../../../common/cube-trend-simulator/cube-trend-simulator.component';
import { SimulatorConfig } from '../../../core/models/simulation.model';

@Component({
  selector: 'app-cube-trend-formation-factor',
  standalone: true,
  imports: [CubeTrendSimulatorComponent],
  templateUrl: './cube-trend-formation-factor.component.html',
  styleUrl: './cube-trend-formation-factor.component.scss',
})
export class CubeTrendFormationFactorComponent {
  readonly config: SimulatorConfig = {
    title: 'Subsample - Cube Trend Formation Factor Simulation',
    simulatorType: SimulatorType.SubsampleCubeTrendFF,
  };
}
